function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import ElementCreator from "../../../utils/element-creator";
/**
 * Tooltip template for creating a new tooltip element with the given options and using the komodo-tooltip lite component
 * @param {TooltipOptions} options
 * @param {() => void} closeIconFunction
 * @returns {HTMLElement}
 */ export var tooltipTemplate = function(options, closeIconFunction) {
    var tooltipDiv = ElementCreator.createDiv({
        id: options.componentId
    }).addClass("kmd-tooltip", "kmd-tooltip--bottom").setAttributes({
        "data-kmd-tooltip-for": "#".concat(options.targetId)
    }).build();
    if (options.classes) {
        var _tooltipDiv_classList;
        (_tooltipDiv_classList = tooltipDiv.classList).add.apply(_tooltipDiv_classList, _to_consumable_array(options.classes));
    }
    tooltipDiv.style.borderRadius = "8px";
    tooltipDiv.style.position = "fixed";
    tooltipDiv.style.zIndex = "1001";
    var tooltipArrow = ElementCreator.createSpan().addClass("kmd-tooltip__arrow").build();
    tooltipDiv.appendChild(tooltipArrow);
    if (options.title) {
        addTooltipHeader(tooltipDiv, options.title);
    }
    var tooltipBody = ElementCreator.createDiv().addClass("kmd-tooltip__body").build();
    tooltipBody.innerHTML = options.content;
    tooltipBody.style.padding = "16px";
    tooltipDiv.appendChild(tooltipBody);
    var closeTooltipIconSVG = ElementCreator.createSVG().build();
    closeTooltipIconSVG.id = "close-tooltip-icon" + options.componentId;
    // Set svg attributes
    closeTooltipIconSVG.setAttribute("width", "14");
    closeTooltipIconSVG.setAttribute("height", "14");
    closeTooltipIconSVG.setAttribute("viewBox", "0 0 14 14");
    closeTooltipIconSVG.setAttribute("fill", "none");
    closeTooltipIconSVG.style.position = "absolute";
    closeTooltipIconSVG.style.top = "16px";
    closeTooltipIconSVG.style.right = "16px";
    closeTooltipIconSVG.style.cursor = "pointer";
    var line1 = document.createElementNS("http://www.w3.org/2000/svg", "path");
    line1.setAttribute("fill-rule", "evenodd");
    line1.setAttribute("clip-rule", "evenodd");
    line1.setAttribute("d", "M8.41 7L14 12.58L12.58 14L7 8.41L1.41 14L0 12.58L5.58 7L0 1.41L1.41 0L7 5.58L12.58 0L14 1.41L8.41 7Z");
    line1.setAttribute("fill", "#1B1B1D");
    closeTooltipIconSVG.appendChild(line1);
    tooltipDiv.appendChild(closeTooltipIconSVG);
    if (closeIconFunction) {
        closeTooltipIconSVG.onclick = closeIconFunction;
    }
    return tooltipDiv;
};
/**
 * Add a header to the tooltip element with the given title
 * @param {HTMLElement} tooltipDiv
 * @param {string} title
 */ var addTooltipHeader = function(tooltipDiv, title) {
    var tooltipHeader = ElementCreator.createDiv().addClass("kmd-tooltip__header").build();
    tooltipHeader.textContent = title;
    tooltipDiv.appendChild(tooltipHeader);
};
